<!--begin::Head-->
<!-- <div class="kt-login__head">
		<span class="kt-login__signup-label">Try using other user.</span>&nbsp;&nbsp;
		<a (click)="logout()" href="javascript:;" class="kt-link kt-login__signup-link">{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}</a>
</div> -->
<!--end::Head-->

<!--begin::Form-->
<form class="kt-form" autocomplete="off">
		<!--begin::Action-->
		<div class="kt-login__actions">
			<div class="redirect-button">
				<button (click)="logout()" id="kt_login_signin_submit" class="btn btn-default btn-elevate kt-login__btn-primary">Go to Login</button>
			</div>
		</div>
		<!--end::Action-->
</form>
<!--end::Form-->

<kt-error
	[type]="type"
	[image]="image"
	[code]="code"
	[title]="title | translate"
	[subtitle]="subtitle"
	[desc]="desc | translate"
	[return]="return"></kt-error>

